import axios from "axios";
import Swal from 'sweetalert2'

export default {
    state:{
        allitems:[],
    },
    mutations:{
        setAllItems(state,items){
            state.allitems=items
        }
    },
    actions:{
        async setAllVentas({commit,rootState,getters}){
           await axios.get(`${rootState.urlapi}/facturas`,getters.getTokenUser).then(res=>{
                commit("setAllItems",res.data)
              }).catch(err=>{console.error(err)});
        },
        async setVentasPorFecha({commit,rootState,getters},params){
            try {
                const {data} = await axios.get(`${rootState.urlapi}/facturas/ventasporfecha?${params}`,getters.getTokenUser);
                commit("setAllItems",data)
               // Swal.fire('Consulta Realizada','','success',{showConfirmButton: false,timer:1500})
              } catch (error) {
                console.log(error)
                Swal.fire('Erro al realizar consulta',error.message,'error')
              }
         },
        async createVenta({rootState,getters},item){
            item.idusuario = getters.usuarioAuth.usuario.idusuario
            const data = await axios.post(`${rootState.urlapi}/facturas`,item,getters.getTokenUser)
            return data
        },

        async enviarCorreo({getters},item){
            const {data} = await axios.post(`${getters.getUrlPdf}/email/`,{"datos":item})
            if(data.error){
              Swal.fire(data.msg,data.error,'error')
            }else{
              Swal.fire(data.msg,'','success')
            }
        },
        async generarPdf({getters},item){
            
            try {
                const {data } = await axios.get(`${getters.getUrlApi}/facturadetalles/${item.idfactura}`)
                item.productos = data
                await axios.post(`${getters.getUrlPdf}/${item.size}/`,{"datos":item})
            } catch (error) {
                console.log(error)
            }
        }
    },
    getters:{
        getAllVentas(state){
            return state.allitems
        },
    }
}